// extracted by mini-css-extract-plugin
export default {"status_container":"Environments_status_container__V5-3J","status":"Environments_status__iauE9"};